<style scoped> 
    @import "../assets/css/booking.css";
    /* @import '../assets/style.css'; */
</style>
<template>
    <div class="payment">
        <LoaderPopover v-if="$store.state.loader_popup" />
        <Heading title="Checkout" link="/calendar" />
        <div class="container-fluid mt-50">
            <div class="row">
                <div class="col-xl-8 col-lg-8 col-md-8">
                    <BookingsList @clicked="changePayables" @bookingDate='bookingDate' @close_popover='close_popover' @show_popover='show_popover' :book_id="payment_details.book_id" :multi_book_id="payment_details.multi_book_id" ></BookingsList>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 bg-white cust_details_div">
                    <CustomersList :cust_id="payment_details.cust_id" @close_popover='close_popover' @show_popover='show_popover' :total="booking_total" :booking_date="booking_date" :deposite="deposite" :book_id="payment_details.book_id" :multi_book_id="payment_details.multi_book_id" ></CustomersList>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .payment{
        background : #F5F7FA;
    }
</style>

<script>
    import Heading from '@/components/pageheader_component.vue';
    import BookingsList from '@/components/bookings_list.vue';
    import CustomersList from '@/components/booking_customer_details.vue'; 
    import LoaderPopover from '@/components/loaderpopover_component.vue';
    export default {
        name: 'payment',
        data() {
            return {
                booking_total:'',
                deposite:'',
                payment_details:{},
                booking_date:'',
            }
        },
        components: {
            BookingsList,CustomersList,Heading,LoaderPopover
        },
        created(){
            this.payment_details = this.$session.get('payment_details');
            this.show_popover();
        },
        methods:{
            changePayables(booking_total,deposite){
                this.booking_total = booking_total;
                this.deposite = deposite;
            },
            bookingDate(date){
                this.booking_date = date;
            },
            close_popover(){this.$store.state.loader_popup = false;},
            show_popover(){this.$store.state.loader_popup = true;}
        }
    }
</script>
